/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from 'ethers';
import { Provider, TransactionRequest } from '@ethersproject/providers';
import type { Roulette, RouletteInterface } from '../Roulette';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'have',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'want',
        type: 'address',
      },
    ],
    name: 'OnlyCoordinatorCanFulfill',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'player',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amountWonInBnb',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'enum Roulette.Shape',
        name: 'bet',
        type: 'uint8',
      },
    ],
    name: 'BetClaimed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'player',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amountLostInBnb',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'enum Roulette.Shape',
        name: 'bet',
        type: 'uint8',
      },
    ],
    name: 'BetLost',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'player',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'bnbAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'enum Roulette.Shape',
        name: 'bet',
        type: 'uint8',
      },
    ],
    name: 'BetPlaced',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'BnbHandled',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'player',
        type: 'address',
      },
    ],
    name: 'ClaimedAll',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'bnbAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'sqmAdded',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'usdtAdded',
        type: 'uint256',
      },
    ],
    name: 'LiquidityAdded',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'requestId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'enum Roulette.Shape',
        name: 'outcome',
        type: 'uint8',
      },
    ],
    name: 'OutcomeSet',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'bnbAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'sqmAmount',
        type: 'uint256',
      },
    ],
    name: 'SqmBurned',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'bnbAmount',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'sqmAmount',
        type: 'uint256',
      },
    ],
    name: 'SqmMinted',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'requestId',
        type: 'uint256',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
    ],
    name: 'WheelSpun',
    type: 'event',
  },
  {
    inputs: [],
    name: 'CIRCLE',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'COORDINATOR',
    outputs: [
      {
        internalType: 'contract VRFCoordinatorV2Interface',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'STAR',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'TRIANGLE',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'UMBRELLA',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'VRF_COORDINATOR',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'WHEEL_SPACES',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    name: 'bets',
    outputs: [
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'player',
        type: 'address',
      },
      {
        internalType: 'enum Roulette.Shape',
        name: 'choice',
        type: 'uint8',
      },
      {
        internalType: 'enum Roulette.Status',
        name: 'status',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'bnbForSqmMintSlippage',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'bnbForSqmSwapSlippage',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'bnbForUsdtSwapSlippage',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'bnbHandlingThreshold',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'burnRatio',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'callbackGasLimit',
    outputs: [
      {
        internalType: 'uint32',
        name: '',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: '',
        type: 'bytes',
      },
    ],
    name: 'checkUpkeep',
    outputs: [
      {
        internalType: 'bool',
        name: 'upkeepNeeded',
        type: 'bool',
      },
      {
        internalType: 'bytes',
        name: 'performData',
        type: 'bytes',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'claimAllWinnings',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
    ],
    name: 'claimWinning',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'deploymentTimestamp',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'gamesPlayedToClaim',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getCurrentGameId',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
    ],
    name: 'getGameOutcome',
    outputs: [
      {
        internalType: 'enum Roulette.Shape',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
    ],
    name: 'getGameRequestId',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
    ],
    name: 'getGameStatus',
    outputs: [
      {
        internalType: 'enum Roulette.Status',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
    ],
    name: 'getGameTimestamp',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'player',
        type: 'address',
      },
    ],
    name: 'getGamesPlayedToClaim',
    outputs: [
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
      {
        internalType: 'address',
        name: 'player',
        type: 'address',
      },
    ],
    name: 'getHasPlayerBet',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'player',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
    ],
    name: 'getHasPlayerWon',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getMostRecentWheelSpinTime',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'player',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
    ],
    name: 'getPlayerBet',
    outputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'amount',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'player',
            type: 'address',
          },
          {
            internalType: 'enum Roulette.Shape',
            name: 'choice',
            type: 'uint8',
          },
          {
            internalType: 'enum Roulette.Status',
            name: 'status',
            type: 'uint8',
          },
        ],
        internalType: 'struct Roulette.Bet',
        name: '',
        type: 'tuple',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'gameId',
        type: 'uint256',
      },
    ],
    name: 'getPlayers',
    outputs: [
      {
        internalType: 'address[]',
        name: '',
        type: 'address[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getUpkeepStatus',
    outputs: [
      {
        internalType: 'bool',
        name: 'upKeepNeeded',
        type: 'bool',
      },
      {
        internalType: 'bytes',
        name: 'performData',
        type: 'bytes',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'handleBnb',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_vrfCoordinator',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_oracle',
        type: 'address',
      },
      {
        internalType: 'uint64',
        name: '_subscriptionId',
        type: 'uint64',
      },
      {
        internalType: 'bytes32',
        name: '_keyHash',
        type: 'bytes32',
      },
      {
        internalType: 'address',
        name: '_usdt',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_sqm',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_router',
        type: 'address',
      },
    ],
    name: 'initialize',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'keyHash',
    outputs: [
      {
        internalType: 'bytes32',
        name: '',
        type: 'bytes32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'lpRatio',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'numWords',
    outputs: [
      {
        internalType: 'uint32',
        name: '',
        type: 'uint32',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'oracle',
    outputs: [
      {
        internalType: 'contract IOracle',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    name: 'outcomes',
    outputs: [
      {
        internalType: 'uint256',
        name: 'requestId',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'timestamp',
        type: 'uint256',
      },
      {
        internalType: 'enum Roulette.Shape',
        name: 'outcome',
        type: 'uint8',
      },
      {
        internalType: 'enum Roulette.Status',
        name: 'status',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes',
        name: 'performData',
        type: 'bytes',
      },
    ],
    name: 'performUpkeep',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'enum Roulette.Shape',
        name: 'choice',
        type: 'uint8',
      },
    ],
    name: 'placeBet',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'requestId',
        type: 'uint256',
      },
      {
        internalType: 'uint256[]',
        name: 'randomWords',
        type: 'uint256[]',
      },
    ],
    name: 'rawFulfillRandomWords',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'requestConfirmations',
    outputs: [
      {
        internalType: 'uint16',
        name: '',
        type: 'uint16',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'roundsPlayed',
    outputs: [
      {
        internalType: 'uint256',
        name: '_value',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'router',
    outputs: [
      {
        internalType: 'contract IUniswapV2Router02',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_newSlippage',
        type: 'uint256',
      },
    ],
    name: 'setBnbForSqmMintSlippage',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_newSlippage',
        type: 'uint256',
      },
    ],
    name: 'setBnbForSqmSwapSlippage',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_newSlippage',
        type: 'uint256',
      },
    ],
    name: 'setBnbForUsdtSwapSlippage',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_threshold',
        type: 'uint256',
      },
    ],
    name: 'setBnbHandlingThreshold',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_burnRatio',
        type: 'uint256',
      },
    ],
    name: 'setBurnRatio',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_gasLimit',
        type: 'uint32',
      },
    ],
    name: 'setCallbackGasLimit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'bytes32',
        name: '_keyHash',
        type: 'bytes32',
      },
    ],
    name: 'setKeyHash',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_lpRatio',
        type: 'uint256',
      },
    ],
    name: 'setLpRatio',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint16',
        name: '_requestConfirmations',
        type: 'uint16',
      },
    ],
    name: 'setRequestConfirmations',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint64',
        name: '_subscriptionId',
        type: 'uint64',
      },
    ],
    name: 'setSubscriptionId',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_time',
        type: 'uint256',
      },
    ],
    name: 'setWheelInterval',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'spinWheel',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'sqm',
    outputs: [
      {
        internalType: 'contract ISQM',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'subscriptionId',
    outputs: [
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'usdt',
    outputs: [
      {
        internalType: 'contract IERC20',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'wheelInterval',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
];

const _bytecode =
  '0x608060405234801561001057600080fd5b50614115806100206000396000f3fe6080604052600436106103b75760003560e01c80637dc0d1d0116101f2578063c7790c5b1161010d578063f644b3bb116100a0578063f887ea401161006f578063f887ea4014610b8d578063f9d66b9f14610bad578063fa2399fa14610bcd578063fc33586214610bed57600080fd5b8063f644b3bb14610ade578063f6f0f98314610b4c578063f70b6f8c14610b62578063f7efd0e614610b7857600080fd5b8063ec7e9256116100dc578063ec7e92561461075f578063eed2a14714610a51578063efeb5f5814610aa9578063f2fde38b14610abe57600080fd5b8063c7790c5b146109f0578063ea7b4f7714610a06578063eaa9f0c414610a26578063eb4be86a14610a3b57600080fd5b80639854471011610185578063a611ae2011610154578063a611ae2014610965578063b0fb162f14610985578063bdad7047146109ba578063bfc12c05146109da57600080fd5b806398544710146108fb578063a26354011461091b578063a4d89e7714610930578063a4eb718c1461094557600080fd5b80638da5cb5b116101c15780638da5cb5b1461088757806392e9d048146108a55780639370131f146108bb57806395e0ae2c146108db57600080fd5b80637dc0d1d0146107fa5780637ec5c9c11461081a5780638824f5a71461083a5780638d0bc5411461085a57600080fd5b8063460e2049116102e2578063639475ca11610275578063715018a611610244578063715018a6146107745780637a76f096146107895780637ccfd7fc146107a95780637d85e4f4146107cd57600080fd5b8063639475ca146106f357806369defb881461071a5780636e04ff0d1461073157806371459c151461075f57600080fd5b80635f2e5d45116102b15780635f2e5d45146106705780636104f6461461069d5780636129f0a3146106bd57806361728f39146106dd57600080fd5b8063460e2049146105ed5780635192c82c1461061a57806359774655146106305780635be1a7f91461065057600080fd5b80631fe543e31161035a5780633b2bcbf1116103295780633b2bcbf1146105845780633de6dcfa146105a457806343046844146105ba5780634585e33b146105cd57600080fd5b80631fe543e3146104e257806324f74697146105025780632c2b6bb0146105345780632f48ab7d1461056457600080fd5b80630d690829116103965780630d6908291461045d5780630f1bf45414610480578063159322c9146104ad57806315ecef92146104cd57600080fd5b80624ed38c146103bc57806305f6a924146103de57806309c1ba2e1461041b575b600080fd5b3480156103c857600080fd5b506103dc6103d73660046137c6565b610c02565b005b3480156103ea57600080fd5b506099546103fe906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b34801561042757600080fd5b50609e5461044490640100000000900467ffffffffffffffff1681565b60405167ffffffffffffffff9091168152602001610412565b34801561046957600080fd5b50610472610ca7565b604051908152602001610412565b34801561048c57600080fd5b506104a061049b3660046137c6565b610ced565b6040516104129190613809565b3480156104b957600080fd5b506103dc6104c83660046137c6565b610d37565b3480156104d957600080fd5b506103dc610d66565b3480156104ee57600080fd5b506103dc6104fd366004613882565b610fcb565b34801561050e57600080fd5b50609e5461051f9063ffffffff1681565b60405163ffffffff9091168152602001610412565b34801561054057600080fd5b5061055461054f366004613939565b611019565b6040519015158152602001610412565b34801561057057600080fd5b50609a546103fe906001600160a01b031681565b34801561059057600080fd5b506098546103fe906001600160a01b031681565b3480156105b057600080fd5b5061047260a75481565b6103dc6105c8366004613965565b6110b7565b3480156105d957600080fd5b506103dc6105e8366004613986565b6113ed565b3480156105f957600080fd5b5061060d6106083660046137c6565b611503565b6040516104129190613a3c565b34801561062657600080fd5b50610472609f5481565b34801561063c57600080fd5b50609b546103fe906001600160a01b031681565b34801561065c57600080fd5b506103dc61066b3660046137c6565b61159c565b34801561067c57600080fd5b5061069061068b366004613a4f565b611639565b6040516104129190613a6c565b3480156106a957600080fd5b506104726106b8366004613939565b6116a5565b3480156106c957600080fd5b506104726106d83660046137c6565b6116d6565b3480156106e957600080fd5b50610472609d5481565b3480156106ff57600080fd5b50610708600981565b60405160ff9091168152602001610412565b34801561072657600080fd5b5060a6546104729081565b34801561073d57600080fd5b5061075161074c366004613986565b611718565b604051610412929190613ab0565b34801561076b57600080fd5b50610708600d81565b34801561078057600080fd5b506103dc61172f565b34801561079557600080fd5b506103dc6107a43660046137c6565b611765565b3480156107b557600080fd5b50609e5461051f90600160701b900463ffffffff1681565b3480156107d957600080fd5b506107ed6107e8366004613939565b611805565b6040516104129190613b1f565b34801561080657600080fd5b5060a2546103fe906001600160a01b031681565b34801561082657600080fd5b50610554610835366004613b60565b61190e565b34801561084657600080fd5b506103dc610855366004613b90565b61196a565b34801561086657600080fd5b5061087a6108753660046137c6565b611a35565b6040516104129190613bb4565b34801561089357600080fd5b506065546001600160a01b03166103fe565b3480156108b157600080fd5b5061047260a45481565b3480156108c757600080fd5b506103dc6108d63660046137c6565b611a7a565b3480156108e757600080fd5b506104726108f63660046137c6565b611b10565b34801561090757600080fd5b506103dc6109163660046137c6565b611b4f565b34801561092757600080fd5b50610472611be1565b34801561093c57600080fd5b50610708600c81565b34801561095157600080fd5b506103dc610960366004613bc2565b611bf1565b34801561097157600080fd5b506103dc6109803660046137c6565b611cad565b34801561099157600080fd5b50609e546109a790600160601b900461ffff1681565b60405161ffff9091168152602001610412565b3480156109c657600080fd5b506103dc6109d53660046137c6565b611d3f565b3480156109e657600080fd5b5061047260a85481565b3480156109fc57600080fd5b5061047260a35481565b348015610a1257600080fd5b506103dc610a21366004613c05565b611dda565b348015610a3257600080fd5b50610751611ead565b348015610a4757600080fd5b5061047260a15481565b348015610a5d57600080fd5b50610a99610a6c3660046137c6565b60ab6020526000908152604090208054600182015460049092015490919060ff8082169161010090041684565b6040516104129493929190613c20565b348015610ab557600080fd5b506103dc611f57565b348015610aca57600080fd5b506103dc610ad9366004613a4f565b6120c2565b348015610aea57600080fd5b50610b3c610af9366004613b60565b60a9602090815260009283526040808420909152908252902080546001909101546001600160a01b0381169060ff600160a01b8204811691600160a81b90041684565b6040516104129493929190613c51565b348015610b5857600080fd5b5061047260a55481565b348015610b6e57600080fd5b5061047260a05481565b348015610b8457600080fd5b506103dc61215d565b348015610b9957600080fd5b50609c546103fe906001600160a01b031681565b348015610bb957600080fd5b506103dc610bc8366004613c74565b612574565b348015610bd957600080fd5b506103dc610be83660046137c6565b612606565b348015610bf957600080fd5b50610708600581565b6065546001600160a01b03163314610c355760405162461bcd60e51b8152600401610c2c90613cff565b60405180910390fd5b670de0b6b3a7640000811115610ca25760405162461bcd60e51b815260206004820152602c60248201527f736574426e62466f725573647453776170536c6970706167653a20736c69707060448201526b0c2ceca40e8dede40d0d2ced60a31b6064820152608401610c2c565b60a455565b6000610cb260a65490565b610cbd575060a85490565b60ab60006001610ccc60a65490565b610cd69190613d4a565b815260200190815260200160002060010154905090565b600081610cf960a65490565b811115610d185760405162461bcd60e51b8152600401610c2c90613d61565b5050600090815260ab6020526040902060040154610100900460ff1690565b6065546001600160a01b03163314610d615760405162461bcd60e51b8152600401610c2c90613cff565b60a555565b60a754306001600160a01b0316630d6908296040518163ffffffff1660e01b815260040160206040518083038186803b158015610da257600080fd5b505afa158015610db6573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610dda9190613d8e565b610de49042613d4a565b1015610e325760405162461bcd60e51b815260206004820152601b60248201527f7370696e576865656c3a20546f6f20736f6f6e20746f207370696e00000000006044820152606401610c2c565b6000610e3d60a65490565b600081815260ab6020526040902060030154909150610e9e5760405162461bcd60e51b815260206004820152601a60248201527f7370696e576865656c3a204e6f206265747320746f207370696e0000000000006044820152606401610c2c565b609854609d54609e546040516305d3b1d360e41b81526004810192909252640100000000810467ffffffffffffffff166024830152600160601b810461ffff16604483015263ffffffff8082166064840152600160701b9091041660848201526000916001600160a01b031690635d3b1d309060a401602060405180830381600087803b158015610f2e57600080fd5b505af1158015610f42573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f669190613d8e565b600083815260ab60205260409020818155426001909101559050610f8e60a680546001019055565b60408051828152602081018490527f217f32391bfbf9cd5ec9c26dcda30cdde94e77547d2c2f6ead4eab2e8ee43758910160405180910390a15050565b6097546001600160a01b0316331461100b5760975460405163073e64fd60e21b81523360048201526001600160a01b039091166024820152604401610c2c565b61101582826126c1565b5050565b60008161102560a65490565b8111156110445760405162461bcd60e51b8152600401610c2c90613d61565b600083815260a9602090815260408083206001600160a01b0388168452909152902060010154600160a01b900460ff166004811115611085576110856137df565b600084815260ab6020526040902060049081015460ff16908111156110ac576110ac6137df565b1491505b5092915050565b600260015414156110da5760405162461bcd60e51b8152600401610c2c90613da7565b6002600155667c5850872380003414806110fb57503467016345785d8a0000145b8061110d5750346703782dace9d90000145b8061111f5750346706f05b59d3b20000145b80611131575034670de0b6b3a7640000145b61117d5760405162461bcd60e51b815260206004820152601d60248201527f706c6163654265743a20496e636f7272656374206265742076616c75650000006044820152606401610c2c565b6000816004811115611191576111916137df565b14156111df5760405162461bcd60e51b815260206004820181905260248201527f706c6163654265743a20496e636f72726563742073686170652063686f6963656044820152606401610c2c565b60006111ea60a65490565b600081815260ab6020908152604080832033845260020190915290205490915060ff161561126a5760405162461bcd60e51b815260206004820152602760248201527f706c6163654265743a20596f75206861766520616c726561647920706c6163656044820152661908184818995d60ca1b6064820152608401610c2c565b600081815260ab6020908152604080832033808552600282018452828520805460ff191660019081179091556003909201805480840182559086528486200180546001600160a01b0319168217905580855260aa845282852080549283018155855293839020018490558051608081018252348152918201929092529081018360048111156112fb576112fb6137df565b815260200160009052600082815260a96020908152604080832033845282529182902083518155908301516001820180546001600160a01b03929092166001600160a01b031983168117825593850151929390916001600160a81b03191617600160a01b836004811115611371576113716137df565b021790555060608201518160010160156101000a81548160ff021916908360018111156113a0576113a06137df565b0217905550506040513391507fe90186097616cbeb30ffc786b44501e1362f5e0a316a96c5ab82a0551f9d2f05906113dd90849034908790613dde565b60405180910390a2505060018055565b6000806113f8611ead565b9150915081801561142657508383604051611414929190613e01565b60405180910390208180519060200120145b156114fd57600080828060200190518101906114429190613e21565b9150915081156114a057306001600160a01b03166315ecef926040518163ffffffff1660e01b8152600401600060405180830381600087803b15801561148757600080fd5b505af115801561149b573d6000803e3d6000fd5b505050505b80156114fa57306001600160a01b031663f7efd0e66040518163ffffffff1660e01b8152600401600060405180830381600087803b1580156114e157600080fd5b505af11580156114f5573d6000803e3d6000fd5b505050505b50505b50505050565b60608161150f60a65490565b81111561152e5760405162461bcd60e51b8152600401610c2c90613d61565b600083815260ab60209081526040918290206003018054835181840281018401909452808452909183018282801561158f57602002820191906000526020600020905b81546001600160a01b03168152600190910190602001808311611571575b5050505050915050919050565b6065546001600160a01b031633146115c65760405162461bcd60e51b8152600401610c2c90613cff565b8060a75414156116345760405162461bcd60e51b815260206004820152603360248201527f736574576865656c496e74657276616c3a20546869732074696d6520696e74656044820152721c9d985b081a5cc8185b1c9958591e481cd95d606a1b6064820152608401610c2c565b60a755565b6001600160a01b038116600090815260aa602090815260409182902080548351818402810184019094528084526060939283018282801561169957602002820191906000526020600020905b815481526020019060010190808311611685575b50505050509050919050565b60aa60205281600052604060002081815481106116c157600080fd5b90600052602060002001600091509150505481565b6000816116e260a65490565b8111156117015760405162461bcd60e51b8152600401610c2c90613d61565b5050600090815260ab602052604090206001015490565b60006060611724611ead565b909590945092505050565b6065546001600160a01b031633146117595760405162461bcd60e51b8152600401610c2c90613cff565b61176360006127fc565b565b6065546001600160a01b0316331461178f5760405162461bcd60e51b8152600401610c2c90613cff565b8060a15414156118005760405162461bcd60e51b815260206004820152603660248201527f736574426e6248616e646c696e675468726573686f6c643a20546869732074686044820152751c995cda1bdb19081a5cc8185b1c9958591e481cd95d60521b6064820152608401610c2c565b60a155565b61182f60408051608081018252600080825260208201819052909182019081526020016000905290565b8161183960a65490565b8111156118585760405162461bcd60e51b8152600401610c2c90613d61565b600083815260a9602090815260408083206001600160a01b03888116855290835292819020815160808101835281548152600182015494851693810193909352919290830190600160a01b900460ff1660048111156118b9576118b96137df565b60048111156118ca576118ca6137df565b81526020016001820160159054906101000a900460ff1660018111156118f2576118f26137df565b6001811115611903576119036137df565b905250949350505050565b60008261191a60a65490565b8111156119395760405162461bcd60e51b8152600401610c2c90613d61565b5050600091825260ab602090815260408084206001600160a01b039390931684526002909201905290205460ff1690565b6065546001600160a01b031633146119945760405162461bcd60e51b8152600401610c2c90613cff565b609e5461ffff828116600160601b909204161415611a135760405162461bcd60e51b815260206004820152603660248201527f73657452657175657374436f6e6669726d6174696f6e733a20546869732067616044820152751cc81b1a5b5a5d081a5cc8185b1c9958591e481cd95d60521b6064820152608401610c2c565b609e805461ffff909216600160601b0261ffff60601b19909216919091179055565b600081611a4160a65490565b811115611a605760405162461bcd60e51b8152600401610c2c90613d61565b5050600090815260ab602052604090206004015460ff1690565b6065546001600160a01b03163314611aa45760405162461bcd60e51b8152600401610c2c90613cff565b80609f541415611b0b5760405162461bcd60e51b815260206004820152602c60248201527f7365744275726e526174696f3a2054686973206275726e20726174696f20697360448201526b08185b1c9958591e481cd95d60a21b6064820152608401610c2c565b609f55565b600081611b1c60a65490565b811115611b3b5760405162461bcd60e51b8152600401610c2c90613d61565b5050600090815260ab602052604090205490565b6065546001600160a01b03163314611b795760405162461bcd60e51b8152600401610c2c90613cff565b80609d541415611bdc5760405162461bcd60e51b815260206004820152602860248201527f7365744b6579486173683a2054686973206b6579206861736820697320616c726044820152671958591e481cd95d60c21b6064820152608401610c2c565b609d55565b6000611bec60a65490565b905090565b6065546001600160a01b03163314611c1b5760405162461bcd60e51b8152600401610c2c90613cff565b609e5463ffffffff82811691161415611c915760405162461bcd60e51b815260206004820152603260248201527f73657443616c6c6261636b4761734c696d69743a205468697320676173206c696044820152711b5a5d081a5cc8185b1c9958591e481cd95d60721b6064820152608401610c2c565b609e805463ffffffff191663ffffffff92909216919091179055565b6065546001600160a01b03163314611cd75760405162461bcd60e51b8152600401610c2c90613cff565b8060a0541415611d3a5760405162461bcd60e51b815260206004820152602860248201527f7365744c70526174696f3a2054686973206c7020726174696f20697320616c726044820152671958591e481cd95d60c21b6064820152608401610c2c565b60a055565b6065546001600160a01b03163314611d695760405162461bcd60e51b8152600401610c2c90613cff565b670de0b6b3a7640000811115611dd55760405162461bcd60e51b815260206004820152602b60248201527f736574426e62466f7253716d53776170536c6970706167653a20736c6970706160448201526a0ceca40e8dede40d0d2ced60ab1b6064820152608401610c2c565b60a355565b6065546001600160a01b03163314611e045760405162461bcd60e51b8152600401610c2c90613cff565b609e5467ffffffffffffffff828116640100000000909204161415611e7d5760405162461bcd60e51b815260206004820152602960248201527f736574537562736372697074696f6e49643a205468697320696420697320616c6044820152681c9958591e481cd95d60ba1b6064820152608401610c2c565b609e805467ffffffffffffffff909216640100000000026bffffffffffffffff0000000019909216919091179055565b600060606000611ebb610ca7565b905060008060a7548342611ecf9190613d4a565b10158015611efd5750600060ab6000611ee760a65490565b8152602081019190915260400160002060030154115b15611f0757600191505b60a1544710611f14575060015b8180611f1d5750805b94508181604051602001611f3f92919091151582521515602082015260400190565b60405160208183030381529060405293505050509091565b60026001541415611f7a5760405162461bcd60e51b8152600401610c2c90613da7565b600260015533600090815260aa6020526040902054611ff35760405162461bcd60e51b815260206004820152602f60248201527f636c61696d416c6c57696e6e696e67733a20596f752068617665206e6f74207060448201526e6c6179656420616e792067616d657360881b6064820152608401610c2c565b33600090815260aa60205260409020545b80156120905733600090815260aa6020526040902061204990612028600184613d4a565b8154811061203857612038613e54565b90600052602060002001543361284e565b33600090815260aa6020526040902080548061206757612067613e6a565b60019003818190600052602060002001600090559055808061208890613e80565b915050612004565b5060405133907fa81402d20429b2b3224cce54a32d277a0c31233c545221acf4e01cce7824d8e590600090a260018055565b6065546001600160a01b031633146120ec5760405162461bcd60e51b8152600401610c2c90613cff565b6001600160a01b0381166121515760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b6064820152608401610c2c565b61215a816127fc565b50565b600260015414156121805760405162461bcd60e51b8152600401610c2c90613da7565b600260015560a054609f54479160009161219a9190613e97565b609f546121a79084613eaf565b6121b19190613ee4565b9050600060a054609f546121c59190613e97565b60a0546121d29085613eaf565b6121dc9190613ee4565b905060006121eb600283613ee4565b6121f59084613e97565b90506000612204600284613ee4565b9050600061221183612bbd565b90506000836122208784613eaf565b61222a9190613ee4565b905060008461223a600288613ee4565b6122449085613eaf565b61224e9190613ee4565b609b54604051632770a7eb60e21b8152306004820152602481018590529192506001600160a01b031690639dc29fac90604401600060405180830381600087803b15801561229b57600080fd5b505af11580156122af573d6000803e3d6000fd5b5050604080518a8152602081018690527f4361bb0049e34cb04be12d3e673ad93c404555adf8307f2fcba389a2e23fe568935001905060405180910390a160006122f885612ef7565b609b54609c5460405163095ea7b360e01b81526001600160a01b03918216600482015260248101869052929350169063095ea7b390604401602060405180830381600087803b15801561234a57600080fd5b505af115801561235e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906123829190613ef8565b50609a54609c5460405163095ea7b360e01b81526001600160a01b0391821660048201526024810184905291169063095ea7b390604401602060405180830381600087803b1580156123d357600080fd5b505af11580156123e7573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061240b9190613ef8565b50609c54609b54609a546001600160a01b039283169263e8e33700928116911685856001806124426065546001600160a01b031690565b60405160e089901b6001600160e01b03191681526001600160a01b039788166004820152958716602487015260448601949094526064850192909252608484015260a483015290911660c482015260001960e482015261010401606060405180830381600087803b1580156124b657600080fd5b505af11580156124ca573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124ee9190613f13565b505060408051898152602081018590529081018390527fd7f28048575eead8851d024ead087913957dfb4fd1a02b4d1573f5352a5a2be3915060600160405180910390a16040518981527f8fca3f4cb02742c5a8f4b67db1bdbc0fcb2e021ee39fc8a17bfd9b7827b885209060200160405180910390a150506001805550505050505050565b600054610100900460ff1661258f5760005460ff1615612593565b303b155b6125af5760405162461bcd60e51b8152600401610c2c90613f41565b600054610100900460ff161580156125d1576000805461ffff19166101011790555b6125e08888888888888861313a565b61025860a7554260a85580156125fc576000805461ff00191690555b5050505050505050565b600260015414156126295760405162461bcd60e51b8152600401610c2c90613da7565b60026001818155600083815260ab602090815260408083203384529094019052919091205460ff161515146126b05760405162461bcd60e51b815260206004820152602760248201527f636c61696d57696e6e696e673a20596f752068617665206e6f7420706c6163656044820152661908184818995d60ca1b6064820152608401610c2c565b6126ba813361284e565b5060018055565b6000600d60ff16826000815181106126db576126db613e54565b60200260200101516126ed9190613f8f565b905060006005821161270157506001612756565b600982118015906127125750600582115b1561271f57506002612756565b600c82118015906127305750600982115b1561273d57506003612756565b600c8211801561274d5750600d82145b15612756575060045b6000600161276360a65490565b61276d9190613d4a565b600081815260ab602052604090206004908101805461010061ff00198216811783559394508593919261ffff199091169091179060019084908111156127b5576127b56137df565b02179055507f5d07e179c8d9e33627ed1979d448fea4305e77abecf395a49b44b4b862d4a6958582846040516127ed93929190613dde565b60405180910390a15050505050565b606580546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6001600083815260ab6020526040902060040154610100900460ff16600181111561287b5761287b6137df565b146128d35760405162461bcd60e51b815260206004820152602260248201527f636c61696d57696e6e696e673a2047616d65206973206e6f7420636f6d706c65604482015261746560f01b6064820152608401610c2c565b600082815260a9602090815260408083206001600160a01b03858116855290835281842082516080810184528154815260018201549283169481019490945291830190600160a01b900460ff166004811115612931576129316137df565b6004811115612942576129426137df565b81526020016001820160159054906101000a900460ff16600181111561296a5761296a6137df565b600181111561297b5761297b6137df565b9052509050600181606001516001811115612998576129986137df565b14612bb857600083815260a9602090815260408083206001600160a01b03861684528252808320600101805460ff60a81b1916600160a81b17905585835260ab909152902060049081015460ff16908111156129f6576129f66137df565b81604001516004811115612a0c57612a0c6137df565b1415612b6a5760006001600085815260ab6020526040902060049081015460ff1690811115612a3d57612a3d6137df565b1415612a4b57506001612aea565b6002600085815260ab6020526040902060049081015460ff1690811115612a7457612a746137df565b1415612a8257506002612aea565b6003600085815260ab6020526040902060049081015460ff1690811115612aab57612aab6137df565b1415612ab957506003612aea565b600084815260ab6020526040902060049081015460ff1681811115612ae057612ae06137df565b1415612aea5750600b5b612b078260200151828460000151612b029190613eaf565b613179565b5081602001516001600160a01b03167f73b6c67a10640019fcd7c6d59e7655875d26fc22beea176c2c90bd66cc8dfbe085838560000151612b489190613eaf565b8560400151604051612b5c93929190613dde565b60405180910390a250505050565b816001600160a01b03167f13e0365cc8f80615bfe37b81e5b99ece5a49c8e54f6f9a34d8ffc79874403bbc8483600001518460400151604051612baf93929190613dde565b60405180910390a25b505050565b60408051600380825260808201909252600091829190602082016060803683375050609c54604080516315ab88c960e31b815290519394506001600160a01b039091169263ad5c464892506004808301926020929190829003018186803b158015612c2757600080fd5b505afa158015612c3b573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c5f9190613fa3565b81600081518110612c7257612c72613e54565b6001600160a01b039283166020918202929092010152609a54825191169082906001908110612ca357612ca3613e54565b6001600160a01b039283166020918202929092010152609b54825191169082906002908110612cd457612cd4613e54565b6001600160a01b03928316602091820292909201015260a254604051631f1033e760e01b8152600481018690526000929190911690631f1033e790602401602060405180830381600087803b158015612d2c57600080fd5b505af1158015612d40573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612d649190613d8e565b90506000612d748260a3546134f0565b609b546040516370a0823160e01b81523060048201529192506000916001600160a01b03909116906370a082319060240160206040518083038186803b158015612dbd57600080fd5b505afa158015612dd1573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612df59190613d8e565b609c5460405163b6f9de9560e01b81529192506001600160a01b03169063b6f9de95908890612e309086908990309060001990600401613fc0565b6000604051808303818588803b158015612e4957600080fd5b505af1158015612e5d573d6000803e3d6000fd5b5050609b546040516370a0823160e01b8152306004820152600094506001600160a01b0390911692506370a08231915060240160206040518083038186803b158015612ea857600080fd5b505afa158015612ebc573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612ee09190613d8e565b9050612eec8282613d4a565b979650505050505050565b604080516002808252606082018352600092839291906020830190803683375050609c54604080516315ab88c960e31b815290519394506001600160a01b039091169263ad5c464892506004808301926020929190829003018186803b158015612f6057600080fd5b505afa158015612f74573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612f989190613fa3565b81600081518110612fab57612fab613e54565b6001600160a01b039283166020918202929092010152609a54825191169082906001908110612fdc57612fdc613e54565b6001600160a01b03928316602091820292909201015260a254604051630e5517db60e01b8152600481018690526000929190911690630e5517db90602401602060405180830381600087803b15801561303457600080fd5b505af1158015613048573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061306c9190613d8e565b9050600061307c8260a4546134f0565b609c54604051637ff36ab560e01b81529192506000916001600160a01b0390911690637ff36ab59088906130bc9086908990309060001990600401613fc0565b6000604051808303818588803b1580156130d557600080fd5b505af11580156130e9573d6000803e3d6000fd5b50505050506040513d6000823e601f3d908101601f191682016040526131129190810190613ff5565b90508060018151811061312757613127613e54565b6020026020010151945050505050919050565b600054610100900460ff166131615760405162461bcd60e51b8152600401610c2c9061407b565b61317087878787878787613520565b50505050505050565b60408051600380825260808201909252600091829190602082016060803683375050609b5482519293506001600160a01b0316918391506000906131bf576131bf613e54565b6001600160a01b039283166020918202929092010152609a548251911690829060019081106131f0576131f0613e54565b6001600160a01b03928316602091820292909201810191909152609c54604080516315ab88c960e31b81529051919093169263ad5c4648926004808301939192829003018186803b15801561324457600080fd5b505afa158015613258573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061327c9190613fa3565b8160028151811061328f5761328f613e54565b6001600160a01b039283166020918202929092010152609c546040516307c0329d60e21b81526000929190911690631f00ca74906132d390879086906004016140c6565b60006040518083038186803b1580156132eb57600080fd5b505afa1580156132ff573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526133279190810190613ff5565b905060008160008151811061333e5761333e613e54565b602090810291909101015160a254604051631f1033e760e01b8152600481018890529192506000916001600160a01b0390911690631f1033e790602401602060405180830381600087803b15801561339557600080fd5b505af11580156133a9573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906133cd9190613d8e565b905060006133dd8260a554613669565b9050808311156134425760405162461bcd60e51b815260206004820152602a60248201527f5f6d696e7453716d576f7274684f66426e623a20496e76616c696420616d6f756044820152691b9d081d1bc81b5a5b9d60b21b6064820152608401610c2c565b609b546040516340c10f1960e01b81526001600160a01b038a8116600483015260248201869052909116906340c10f1990604401600060405180830381600087803b15801561349057600080fd5b505af11580156134a4573d6000803e3d6000fd5b5050604080518a8152602081018790527f1df32fcf906c0cdee430c64a566e8e9b012fa911caa0b9bf399334a15fa942a9935001905060405180910390a1509093505050505b92915050565b6000670de0b6b3a76400006135058382613d4a565b61350f9085613eaf565b6135199190613ee4565b9392505050565b600054610100900460ff166135475760405162461bcd60e51b8152600401610c2c9061407b565b6135508761367e565b61355861370b565b61356061373a565b60a280546001600160a01b03199081166001600160a01b03988916179091556099805482169888169889179055609e8054609d96909655609880548316909917909855609a8054821694881694909417909355609b8054841692871692909217909155609c80549092169416939093179092556706f05b59d3b2000060a3556702c68af0bb14000060a481905560a5556001609f81905560a055600160701b71ffffffff0000ffffffffffffffff000000001990921664010000000067ffffffffffffffff929092169190910263ffffffff60701b191617176dffff0000000000000000ffffffff19166c030000000000000000000186a0179055670de0b6b3a764000060a155565b6000670de0b6b3a76400006135058382613e97565b600054610100900460ff166136995760005460ff161561369d565b303b155b6136b95760405162461bcd60e51b8152600401610c2c90613f41565b600054610100900460ff161580156136db576000805461ffff19166101011790555b609780546001600160a01b0319166001600160a01b0384161790558015611015576000805461ff00191690555050565b600054610100900460ff166137325760405162461bcd60e51b8152600401610c2c9061407b565b611763613769565b600054610100900460ff166137615760405162461bcd60e51b8152600401610c2c9061407b565b611763613796565b600054610100900460ff166137905760405162461bcd60e51b8152600401610c2c9061407b565b60018055565b600054610100900460ff166137bd5760405162461bcd60e51b8152600401610c2c9061407b565b611763336127fc565b6000602082840312156137d857600080fd5b5035919050565b634e487b7160e01b600052602160045260246000fd5b60028110613805576138056137df565b9052565b602081016134ea82846137f5565b634e487b7160e01b600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff8111828210171561385657613856613817565b604052919050565b600067ffffffffffffffff82111561387857613878613817565b5060051b60200190565b6000806040838503121561389557600080fd5b8235915060208084013567ffffffffffffffff8111156138b457600080fd5b8401601f810186136138c557600080fd5b80356138d86138d38261385e565b61382d565b81815260059190911b820183019083810190888311156138f757600080fd5b928401925b82841015613915578335825292840192908401906138fc565b80955050505050509250929050565b6001600160a01b038116811461215a57600080fd5b6000806040838503121561394c57600080fd5b823561395781613924565b946020939093013593505050565b60006020828403121561397757600080fd5b81356005811061351957600080fd5b6000806020838503121561399957600080fd5b823567ffffffffffffffff808211156139b157600080fd5b818501915085601f8301126139c557600080fd5b8135818111156139d457600080fd5b8660208285010111156139e657600080fd5b60209290920196919550909350505050565b600081518084526020808501945080840160005b83811015613a315781516001600160a01b031687529582019590820190600101613a0c565b509495945050505050565b60208152600061351960208301846139f8565b600060208284031215613a6157600080fd5b813561351981613924565b6020808252825182820181905260009190848201906040850190845b81811015613aa457835183529284019291840191600101613a88565b50909695505050505050565b821515815260006020604081840152835180604085015260005b81811015613ae657858101830151858201606001528201613aca565b81811115613af8576000606083870101525b50601f01601f191692909201606001949350505050565b60058110613805576138056137df565b815181526020808301516001600160a01b0316908201526040808301516080830191613b4d90840182613b0f565b5060608301516110b060608401826137f5565b60008060408385031215613b7357600080fd5b823591506020830135613b8581613924565b809150509250929050565b600060208284031215613ba257600080fd5b813561ffff8116811461351957600080fd5b602081016134ea8284613b0f565b600060208284031215613bd457600080fd5b813563ffffffff8116811461351957600080fd5b803567ffffffffffffffff81168114613c0057600080fd5b919050565b600060208284031215613c1757600080fd5b61351982613be8565b8481526020810184905260808101613c3b6040830185613b0f565b613c4860608301846137f5565b95945050505050565b8481526001600160a01b038416602082015260808101613c3b6040830185613b0f565b600080600080600080600060e0888a031215613c8f57600080fd5b8735613c9a81613924565b96506020880135613caa81613924565b9550613cb860408901613be8565b9450606088013593506080880135613ccf81613924565b925060a0880135613cdf81613924565b915060c0880135613cef81613924565b8091505092959891949750929550565b6020808252818101527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604082015260600190565b634e487b7160e01b600052601160045260246000fd5b600082821015613d5c57613d5c613d34565b500390565b60208082526013908201527211d85b5948191bd95cc81b9bdd08195e1a5cdd606a1b604082015260600190565b600060208284031215613da057600080fd5b5051919050565b6020808252601f908201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c00604082015260600190565b8381526020810183905260608101613df96040830184613b0f565b949350505050565b8183823760009101908152919050565b80518015158114613c0057600080fd5b60008060408385031215613e3457600080fd5b613e3d83613e11565b9150613e4b60208401613e11565b90509250929050565b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052603160045260246000fd5b600081613e8f57613e8f613d34565b506000190190565b60008219821115613eaa57613eaa613d34565b500190565b6000816000190483118215151615613ec957613ec9613d34565b500290565b634e487b7160e01b600052601260045260246000fd5b600082613ef357613ef3613ece565b500490565b600060208284031215613f0a57600080fd5b61351982613e11565b600080600060608486031215613f2857600080fd5b8351925060208401519150604084015190509250925092565b6020808252602e908201527f496e697469616c697a61626c653a20636f6e747261637420697320616c72656160408201526d191e481a5b9a5d1a585b1a5e995960921b606082015260800190565b600082613f9e57613f9e613ece565b500690565b600060208284031215613fb557600080fd5b815161351981613924565b848152608060208201526000613fd960808301866139f8565b6001600160a01b03949094166040830152506060015292915050565b6000602080838503121561400857600080fd5b825167ffffffffffffffff81111561401f57600080fd5b8301601f8101851361403057600080fd5b805161403e6138d38261385e565b81815260059190911b8201830190838101908783111561405d57600080fd5b928401925b82841015612eec57835182529284019290840190614062565b6020808252602b908201527f496e697469616c697a61626c653a20636f6e7472616374206973206e6f74206960408201526a6e697469616c697a696e6760a81b606082015260800190565b828152604060208201526000613df960408301846139f856fea2646970667358221220908081b2573d2a0c8761d45c0fa200699ca2f86d884efeba6b32e959eee5782a64736f6c63430008090033';

type RouletteConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: RouletteConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class Roulette__factory extends ContractFactory {
  constructor(...args: RouletteConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides?: Overrides & { from?: string | Promise<string> }): Promise<Roulette> {
    return super.deploy(overrides || {}) as Promise<Roulette>;
  }
  getDeployTransaction(overrides?: Overrides & { from?: string | Promise<string> }): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Roulette {
    return super.attach(address) as Roulette;
  }
  connect(signer: Signer): Roulette__factory {
    return super.connect(signer) as Roulette__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RouletteInterface {
    return new utils.Interface(_abi) as RouletteInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Roulette {
    return new Contract(address, _abi, signerOrProvider) as Roulette;
  }
}
